import { render } from "./TrsxnsLoaderModal.vue?vue&type=template&id=ba4e840e"
import script from "./TrsxnsLoaderModal.vue?vue&type=script&lang=js"
export * from "./TrsxnsLoaderModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__